module.exports = __webpack_public_path__ + "static/media/jeongseok.aaa8d85c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jeongseok.jpg
// module id = 56
// module chunks = 0